import { render } from "./CheckBox.vue?vue&type=template&id=638741bb&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=638741bb&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638741bb"]])

export default __exports__